import { useState, useCallback, lazy, Suspense } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOpenChecksForMerge } from '@reducers/storeChecks';
import { mergeOpenCheck } from '@reducers/checks';
import Loader from '@components/common/Loader/newLoaderModal';

const MergeChecksModal = lazy(() =>
  import('@components/checksCommon/MergeChecksModalCopy')
);

const useMergeCheck = ({
  checkData,
  deviceInfo,
  userInfo,
  serverAppTheme,
  setErrorPopUp,
  onClose,
}) => {
  const dispatch = useDispatch();
  const openChecksData = useSelector(
    state => state.storeChecks?.openCheckListHashTable
  );
  const [isOpen, setIsOpen] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const open = useCallback(() => {
    setIsOpen(true);
    dispatch(fetchOpenChecksForMerge(deviceInfo?.storeId)).catch(err =>
      setErrorPopUp({ res: err.message })
    );
  }, [dispatch, deviceInfo?.storeId, setErrorPopUp]);

  const handleMergeOpen = useCallback(
    addedChecks => {
      if (!addedChecks?.length) return;
      const data = {
        storeId: deviceInfo?.storeId,
        deviceId: deviceInfo?.deviceId,
        employeeId: userInfo?.id,
        checkHeaderId: checkData?.id,
        mergedCheckHeaderIds: addedChecks,
      };
      setIsLoading(true);
      dispatch(mergeOpenCheck(data))
        .then(() => {
          setIsLoading(false);
          setIsOpen(false);
          setConfirmationModal(false);
          onClose(true);
        })
        .catch(err => {
          setIsLoading(false);
          setConfirmationModal(false);
          setErrorPopUp({ res: err?.message });
        });
    },
    [dispatch, deviceInfo, userInfo, checkData, onClose, setErrorPopUp]
  );

  const jsx = (
    <>
      {isLoading && <Loader />}
      <Suspense fallback={null}>
        {isOpen && (
          <MergeChecksModal
            isMergeCheckOpen={isOpen}
            OpenChecksData={openChecksData ?? {}}
            handleMergeOpen={handleMergeOpen}
            onClose={() => setIsOpen(false)}
            currentCheckId={checkData?.id}
            serverAppTheme={serverAppTheme}
            checkData={checkData}
            setConfirmationModal={setConfirmationModal}
            confirmationModal={confirmationModal}
            seats={checkData}
            setErrorPopUp={setErrorPopUp}
          />
        )}
      </Suspense>
    </>
  );

  return { open, jsx };
};

export default useMergeCheck;
